import type { FC, AnchorHTMLAttributes } from "react";
import Markdown, { Components } from "react-markdown";
import { EntryModel, EntryType } from "lib/models";

const CustomLink: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => {
  return (
    <a
      className="text-blue-700 underline hover:text-blue-900"
      {...props}
    >
      {props.children}
    </a>
  );
};

interface ContentContainerProps {
  entry: EntryModel;
}

function BucketContentContainer(props: ContentContainerProps) {

  const components: Components = {
    a: CustomLink,
  };

  const formatDate = (dateString: Date): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    });
  };

  const getText = (entry: EntryModel) => {
    if (entry.data.type == EntryType.TEXT) {
      return entry.data.text;
    }
    return "";
  };

  return (
      <div className="flex w-full">
        <div className="w-full rounded-xl p-2 border">
          <Markdown components={components}>
            {getText(props.entry)}
          </Markdown>
          <div className="text-xs text-palette-1">{formatDate(props.entry.createdAt)}</div>
        </div>
      </div>
  );
}

export default BucketContentContainer;
